import React from 'react'

interface UseModalOptions {
  isInitiallyToggled?: boolean
}

interface UseModalReturn {
  isOpen: boolean
  handleClose: () => void
  handleOpen: () => void
}

export const useModal = ({
  isInitiallyToggled = false,
}: UseModalOptions = {}): UseModalReturn => {
  const [isOpen, setIsOpen] = React.useState(isInitiallyToggled)

  const handleClose = React.useCallback(() => setIsOpen(false), [setIsOpen])

  const handleOpen = React.useCallback(() => setIsOpen(true), [setIsOpen])

  return {
    isOpen,
    handleClose,
    handleOpen,
  }
}
